export const saveState = (state) => {
  try {
    // Only persist critical parts of the state that need to survive refreshes
    const persistedState = {
      theme: state.theme,
      app: state.app,
    }
    const serializedState = JSON.stringify(persistedState)
    localStorage.setItem('reduxState', serializedState)
  } catch (e) {
    console.error('Could not save state', e)
  }
}

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('reduxState')
    if (serializedState === null) {
      return undefined
    }
    return JSON.parse(serializedState)
  } catch (e) {
    console.error('Could not load state', e)
    // If there's an error, clear the corrupted state
    localStorage.removeItem('reduxState')
    return undefined
  }
}
